<template>
    <Modal title="用户信息" v-model="isShow"  @on-cancel='handle'>
    <div class="myModal">
        <Form :label-width="100" inline>
          <Row :gutter="16">
            <Col>
              <Col span="12">
                <FormItem label="用户名称">
                  {{userinfos.nickname}}
                </FormItem>
              </Col>
            </Col>
            <Col>
              <Col span="12">
                <FormItem label="手机号">
                  {{userinfos.phone}}
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="海星">
                  {{userinfos.starfish}}
                </FormItem>
              </Col>
            </Col>
            <Col>
              <Col span="12">
                <FormItem label="可用积分">
                  {{userinfos.integral}}
                </FormItem>
              </Col>
            </Col>
            <Col>
              <Col span="12">
                <FormItem label="已住多少晚">
                  {{userinfos.homes_checkIn_num}}
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="累计省多少钱">
                  {{userinfos.saving_fee}}
                </FormItem>
              </Col>
            </Col>
            <Col>
              <Col span="24">
                <FormItem label="注册时间">
                  {{userinfos.ctime}}
                </FormItem>
              </Col>
            </Col>
          </Row>
        </Form>
    </div>
      <div slot="footer">
        <button type="button" class="ivu-btn ivu-btn-primary ivu-btn-long common-form-button" @click="handle(true)">
          <span>确认</span>
        </button>
      </div>
  </Modal>
</template>
<style scoped>
  .myModal {
    margin-left: 20px;
    margin-top: 20px;
  }
</style>
<script>
import { userInfo } from '@/api/user'

export default {
  name: 'usershow',
  props: ['formShow', 'id'],
  data () {
    return {
      isShow: false,
      userid: 0,
      userinfos: []
    }
  },
  watch: {
    formShow (val) {
      this.isShow = val
    },
    id (val) {
      this.userid = val
      this.userInfo()
    }
  },
  created () {
  },
  methods: {
    handle (status) {
      this.$emit('updateStatusModel3', false)
    },
    userInfo () {
      userInfo(this.userid).then(res => {
        this.userinfos = res.data
        // this.userList()
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    }
  }
}
</script>
